import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
import LandingOffersSlider from '@/shared/ui/landing/LandingOffersSlider.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingOfferSection',
  props: {
    title: null,
    items: null
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'LandingOfferSection'
    });
    return {
      __sfc: true,
      LandingOffersSlider: LandingOffersSlider
    };
  }
});